<template>
	<div>
		<header class="page-title">
			<h2>Edit Provider List</h2>
			<div class="ml-auto">
				<a href="provider-lists__edit-page" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="flex box">
			<div class="six-lg">
				<div class="card">
					<header class="card-header language-list">
						<nav>
							<ul class="tabs">
								<li class="active">
									<!-- <img src=""> -->
									<a href="#">English</a>
								</li>
								<li>
									<!-- <img src=""> -->
									<a href="#">German</a>
								</li>
							</ul>
						</nav>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="prologue">Prologue</label>
							<textarea id="prologue" class="textarea-small" name="prologue"></textarea>
						</div>
						<div class="form-group">
							<label>Taglines</label>
							<table>
								<thead>
									<tr>
										<th>Provider</th>
										<th>Tagline</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1. NordVPN</td>
										<td>
											<input type="text">
										</td>
									</tr>
									<tr>
										<td>2. ExpressVPN</td>
										<td>
											<input type="text">
										</td>
									</tr>
									<tr>
										<td>3. PrivateInternetAccess</td>
										<td>
											<input type="text">
										</td>
									</tr>
									<tr>
										<td>4. Buffered</td>
										<td>
											<input type="text">
										</td>
									</tr>
									<tr>
										<td>5. aVPN</td>
										<td>
											<input type="text">
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="form-group">
					<label for="affiliate-tag">Affiliate Tag</label>
					<input id="affiliate-tag" type="text" name="affiliate-tag">
				</div>
			</div>
			<div class="six-lg">
				<div class="card">
					<header class="card-header">
						<h4 class="card-title">Partnership</h4>
					</header>
					<div class="card-body">
						<table>
							<thead>
								<tr>
									<th>Name</th>
									<th>ID</th>
									<th>URL</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Index.hu</td>
									<td>index</td>
									<td>https://proprivacy.com/api/asd/225588-4466</td>
									<td class="nowrap">
										<a href="#" class="btn btn-icon btn-primary" title="Copy to Clipboard"><i class="fas fa-fw fa-copy"></i></a>
										<a href="#" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
									</td>
								</tr>
								<tr>
									<td>444.hu</td>
									<td>444</td>
									<td>https://proprivacy.com/api/asd/333444-4466</td>
									<td class="nowrap">
										<a href="#" class="btn btn-icon btn-primary" title="Copy to Clipboard"><i class="fas fa-fw fa-copy"></i></a>
										<a href="#" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
									</td>
								</tr>
								<tr>
									<td>AndrasFabian.com</td>
									<td>andrasfab</td>
									<td>https://proprivacy.com/api/asd/123456-4466</td>
									<td class="nowrap">
										<a href="#" class="btn btn-icon btn-primary" title="Copy to Clipboard"><i class="fas fa-fw fa-copy"></i></a>
										<a href="#" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="mt-2 text-right">
							<a href="provider-lists__edit-page__sharing-tab__create-edit-partner-modal" class="btn btn-md btn-success"><i class="fas fa-plus"></i> Add New Partner</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ProviderListEditorSharing"
	}
</script>

<style scoped>

</style>
